import { useEffect, useState } from "react";
import { User } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";

const ROLE_TO_COLUMN: Record<string, string> = {
  "Director": "pp_delete_project__project_director",
  "Manager": "pp_delete_project__project_manager",
};

export const useDeleteProjectAccess = (user: User | null) => {
  const [canDeleteProject, setCanDeleteProject] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      if (!user?.email) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        const { data: userRow } = await supabase
          .from("users")
          .select("role, company_name")
          .eq("email", user.email)
          .maybeSingle();

        const role = userRow?.role ?? null;
        const companyName = userRow?.company_name ?? null;
        const column = role ? ROLE_TO_COLUMN[role] : undefined;

        if (!column || !companyName) {
          setCanDeleteProject(true);
          return;
        }

        const { data: permissionRow } = await supabase
          .from("project_access_permissions")
          .select(column)
          .eq("company_name", companyName)
          .maybeSingle();

        if (!permissionRow) {
          setCanDeleteProject(true);
          return;
        }

        const value = (permissionRow as unknown as Record<string, unknown>)[column];
        setCanDeleteProject(value !== false);
      } catch (error) {
        console.error("useDeleteProjectAccess error", error);
        setCanDeleteProject(true);
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [user?.email]);

  return { canDeleteProject, loading };
};